import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'tests-import-form',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    langButtons: {
      minHeight: 'auto',
    },
    langButton: {
      padding: theme.spacing(0, 0, 1),
      minWidth: 'auto',
      minHeight: 'auto',
      position: 'relative',
      ...theme.typography.body2,
      color: theme.palette.secondary.main,
      '&:before': {
        content: '""',
        width: '100%',
        height: 3,
        borderRadius: 3,
        position: 'absolute',
        left: 0,
        bottom: 0,
      },
    },
    activeLangButton: {
      ...theme.typography.h5,
      color: theme.palette.text.primary,
      '&:before': {
        backgroundColor: theme.palette.text.primary,
      },
    },
    fileuploaderDropzone: {
      backgroundColor: theme.palette.grey[50],
      border: `1px dashed ${theme.palette.grey[200]}`,
      borderRadius: 14,
      padding: theme.spacing(4),
    },
    activeUploader: {
      backgroundColor: theme.palette.grey[100],
    },
  }),
  options
);

export default useStyles;
